import React from 'react';
import { Cube, Folder, Factory, Quotes, Orders } from 'icons';

export const navConfig = [
  // {
  //   name: 'workspace',
  //   tooltip: 'My Dashboard',
  //   fillParamWithActiveSpace: 'spacePath',
  //   iconName: 'dashboard',
  //   routes: ['home', 'workspace'],
  // },
  {
    name: 'workspace.spaceFiles',
    fillParamWithActiveSpace: 'spacePath',
    tooltip: 'Files',
    icon: <Cube />,
    routes: ['workspace', 'workspace.spaceFiles'],
  },
  {
    name: 'workspace.spaceProjects',
    fillParamWithActiveSpace: 'spacePath',
    tooltip: 'Projects',
    icon: <Folder />,
    routes: ['workspace.spaceProjects'],
  },
  {
    name: 'workspace.rfqs',
    fillParamWithActiveSpace: 'spacePath',
    tooltip: 'RFQs',
    icon: <Factory />,
    routes: [
      'workspace.rfqs',
      'rfq',
      'workspace.intermediator.rfqs',
      'intermediator.rfq',
      'workspace.manufacturer.rfqs',
      'manufacturer.rfq',
    ],
    isRoleSensitive: true,
  },
  {
    name: 'workspace.quotes',
    fillParamWithActiveSpace: 'spacePath',
    tooltip: 'Quotes',
    icon: <Quotes />,
    routes: [
      'workspace.quotes',
      'quote',
      'intermediator.quote',
      'quotes',
      'workspace.intermediator.quotes',
      '',
    ],
    isRoleSensitive: true,
  },
  {
    name: 'workspace.orders',
    fillParamWithActiveSpace: 'spacePath',
    tooltip: 'Orders',
    icon: <Orders />,
    routes: [
      'workspace.orders',
      'order',
      'intermediator.order',
      'workspace.intermediator.orders',
      'intermediator.order',
      'workspace.manufacturer.orders',
      'manufacturer.order',
    ],
    isRoleSensitive: true,
  },
];
